'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var shouldForwardProp = require('@styled-system/should-forward-prop');
var styledSystem = require('styled-system');
var styled = require('@emotion/styled');
var react = require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var shouldForwardProp__default = /*#__PURE__*/_interopDefaultLegacy(shouldForwardProp);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _excluded = ["variant", "color"];
var TextStyled = styled__default["default"]('span', {
  shouldForwardProp: shouldForwardProp__default["default"]
})(styledSystem.variant({
  variants: {
    label: {
      lineHeight: 16,
      fontSize: 12
    },
    headline1: {
      fontSize: 40,
      lineHeight: 42,
      fontWeight: 'bold',
      letterSpacing: 0.5
    },
    headline2: {
      fontSize: 32,
      lineHeight: 34,
      fontWeight: 'bold'
    },
    headline3: {
      fontSize: 24,
      lineHeight: 26,
      fontWeight: 'bold'
    },
    headline4: {
      fontSize: 24,
      lineHeight: 26
    },
    headline5: {
      fontSize: 20,
      lineHeight: 22,
      fontWeight: 'bold'
    },
    headline6: {
      fontSize: 20,
      lineHeight: 22
    },
    paragraph1: {
      fontSize: 18,
      lineHeight: 24
    },
    paragraph2: {
      fontSize: 16,
      lineHeight: 20
    },
    paragraph3: {
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: 20
    },
    paragraph4: {
      fontSize: 14,
      lineHeight: 18
    },
    paragraph5: {
      fontWeight: 'bold',
      fontSize: 14,
      lineHeight: 18
    },
    paragraph6: {
      fontSize: 12,
      lineHeight: 14
    },
    paragraph7: {
      fontWeight: 'bold',
      fontSize: 12,
      lineHeight: 14
    },
    paragraph8: {
      fontSize: 11,
      lineHeight: 14
    }
  }
}), styledSystem.typography, styledSystem.color, styledSystem.space);
/**
 * @deprecated This component is deprecated and will no longer receive functionality updates. Please avoid using it in new projects.
 * New version is available.
 * @see https://storybook.olxtech.pl/?path=/docs/typography-textcontainer--regular
 */
var Text = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'label' : _ref$variant,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'text-global-primary' : _ref$color,
    props = _objectWithoutProperties__default["default"](_ref, _excluded);
  return react.jsx(TextStyled, _extends__default["default"]({
    variant: variant,
    color: color
  }, props, {
    ref: ref
  }));
});

exports.Text = Text;
//# sourceMappingURL=Text.js.map
